import {
	POST_POPULAR_FETCH,
	POST_POPULAR_FETCH_LOADING,
	POST_POPULAR_FETCH_ERROR,
	POST_POPULAR_PREVIEW_GET,
	POST_POPULAR_PREVIEW_GET_LOADING,
	POST_POPULAR_PREVIEW_GET_ERROR,
	POST_POPULAR_BY_CATEGORY_FETCH,
	POST_POPULAR_BY_CATEGORY_FETCH_LOADING,
	POST_POPULAR_BY_CATEGORY_FETCH_ERROR,
	POST_POPULAR_LOADING,
} from './types'

const initialState = {
	errors: [],
	popularPostsByCategoryLoading: false,
	popularPostsByCategory: [],
	popularPosts: [],
	popularPostsLoading: false,
	popularPostsByCategoryPreview: [],
	popularPostsByCategoryPreviewLoading: false,
	popularPostsPreview: [],
	popularPostsPreviewLoading: false,
	total: 0,
	loading: false,
}

export const state = { ...initialState }

export default {
	[POST_POPULAR_BY_CATEGORY_FETCH_LOADING]: (state, status) => {
		state.popularPostsByCategoryLoading = status
	},

	[POST_POPULAR_BY_CATEGORY_FETCH]: (state, payload) => {
		state.popularPostsByCategory = payload
	},

	[POST_POPULAR_BY_CATEGORY_FETCH_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[POST_POPULAR_FETCH_LOADING]: (state, status) => {
		state.popularPostsLoading = status
	},

	[POST_POPULAR_FETCH]: (state, payload) => {
		state.popularPosts = [...payload.data]
		state.total = payload.meta['last_page']
	},

	[POST_POPULAR_FETCH_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[POST_POPULAR_PREVIEW_GET_LOADING]: (state, status) => {
		state.popularPostsPreviewLoading = status
	},

	[POST_POPULAR_PREVIEW_GET]: (state, payload) => {
		state.popularPostsPreview = [...payload]
	},

	[POST_POPULAR_PREVIEW_GET_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[POST_POPULAR_LOADING]: (state, status) => {
		state.loading = status
	},
}
